import Vue from 'vue'
import Router from 'vue-router'
import Calculation from '@/components/Calculation'
import ThankPage from '@/components/ThankPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/dekujeme',
      name: 'ThankPage',
      component: ThankPage
    },
    {
      path: '*',
      name: 'Calculation',
      component: Calculation
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js